import DATA_EV_DEMO_USE_CASE_1 from "./EV/404EvDemo_UseCase_1";
import DATA_EV_DEMO_USE_CASE_1_EXP_VIDEO from "./EV/405EvDemo_UseCase_1_exp_video";
import DATA_EV_DEMO_USE_CASE_1_DEMO_VIDEO from "./EV/406EvDemo_UseCase_1_demo_video";
import DATA_EV_DEMO_USE_CASE_3 from "./EV/410EvDemo_UseCase_3";
import DATA_EV_DEMO_USE_CASE_3_EXP_VIDEO from "./EV/411EvDemo_UseCase_3_exp_video";
import DATA_EV_DEMO_USE_CASE_3_DEMO_VIDEO from "./EV/412EvDemo_UseCase_3_demo_video";
import DATA_EV_DEMO_USE_CASE_4 from "./EV/414EvDemo_UseCase_4";
import DATA_EV_DEMO_USE_CASE_4_EXP_VIDEO from "./EV/415EvDemo_UseCase_4_exp_video";
import DATA_EV_DEMO_USE_CASE_5 from "./EV/416EvDemo_UseCase_5";
import DATA_EV_DEMO_USE_CASE_5_DEMO_VIDEO from "./EV/417EvDemo_UseCase_5_demo_video";
import { DATA_EV_DEMO_END } from "./EV/419EvDemo_End";
import { DATA_INTRO_EV_1 } from "./Introduction/401DataIntroEV_1";
import { DATA_INTRO_EV_2 } from "./Introduction/402DataIntroEV_2";
import { DATA_USE_CASES_EV } from "./Introduction/403DataUseCasesEV";

export const EV_WORKFLOW = [
  { page: 401, type: "intro-template" as TemplateType, data: DATA_INTRO_EV_1 },
  { page: 402, type: "intro-template" as TemplateType, data: DATA_INTRO_EV_2 },
  {
    page: 403,
    type: "use-cases-template" as TemplateType,
    data: DATA_USE_CASES_EV,
  },
  {
    page: 404,
    type: "video-journey-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_1,
  },
  {
    page: 405,
    type: "full-screen-video-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_1_EXP_VIDEO,
  },
  {
    page: 406,
    type: "full-screen-video-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_1_DEMO_VIDEO,
  },
  {
    page: 410,
    type: "video-journey-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_3,
  },
  {
    page: 411,
    type: "full-screen-video-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_3_EXP_VIDEO,
  },
  {
    page: 412,
    type: "full-screen-video-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_3_DEMO_VIDEO,
  },
  {
    page: 414,
    type: "video-journey-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_4,
  },
  {
    page: 415,
    type: "full-screen-video-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_4_EXP_VIDEO,
  },
  {
    page: 416,
    type: "video-journey-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_5,
  },
  {
    page: 417,
    type: "full-screen-video-template" as TemplateType,
    data: DATA_EV_DEMO_USE_CASE_5_DEMO_VIDEO,
  },
  {
    page: 419,
    type: "end-template" as TemplateType,
    data: DATA_EV_DEMO_END,
  },
  // {
  //   page: 202,
  //   type: "benefits-template" as TemplateType,
  //   data: DATA_BENEFITS_DNA2_1,
  // },
  // {
  //   page: 203,
  //   type: "benefits-template" as TemplateType,
  //   data: DATA_BENEFITS_DNA2_2,
  // },
  // {
  //   page: 204,
  //   type: "characters-template" as TemplateType,
  //   data: DATA_CHARACTERS_DNA2,
  // },
  // {
  //   page: 205,
  //   type: "journey-two-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_1,
  // },
  // {
  //   page: 206,
  //   type: "journey-two-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_2,
  // },
  // {
  //   page: 207,
  //   type: "journey-two-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_3,
  // },
  // {
  //   page: 208,
  //   type: "journey-two-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_4,
  // },
  // {
  //   page: 209,
  //   type: "journey-two-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_5,
  // },
  // {
  //   page: 210,
  //   type: "journey-two-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_6,
  // },
  // {
  //   page: 211,
  //   type: "journey-two-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_7,
  // },
  // {
  //   page: 212,
  //   type: "journey-two-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_8,
  // },
  // {
  //   page: 213,
  //   type: "journey-two-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_9,
  // },
  // {
  //   page: 214,
  //   type: "end-template" as TemplateType,
  //   data: DATA_DS_DEMO_DNA2_END,
  // },
];
